import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-application-configuration',
  templateUrl: './application-configuration.component.html',
  styleUrls: ['./application-configuration.component.scss'],
})
export class ApplicationConfigurationComponent
  extends BaseListCtl
  implements OnInit {
  activeTab: any = 'email';
  applicationId: number = 0; // store app id as number

  constructor(locator: ServiceLocatorService, route: ActivatedRoute) {
    //  pass endpoint + required services to BaseListCtl
    super('applicationConfiguration', locator, route);
    let _self = this;
    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    // _self.form.searchParams['appId'] = _self.applicationId;
  }

  setTab(tab: any) {
    this.form.data = {};

    this.activeTab = tab;
  }

  sendTestEmail() {
    if (!this.applicationId) {
      alert('Application ID is missing!');
        return;
      }

    if (!this.form.data.testEmail) {
      alert('Recipient email is required!');
      return;
    }

    // Split by comma and trim spaces
    let emails = this.form.data.testEmail
      .split(',')
      .map((e: string) => e.trim())
      .filter((e: string) => e.length > 0);

    if (emails.length === 0) {
      alert('Please enter at least one valid email address');
      return;
    }

    // Choose API endpoint
    let url =
      this.locator.config.get('endpoint.applicationconfiguration') +
      (emails.length > 1
        ? '/testemailconfiguration/multi'
        : '/testemailconfiguration');

    const payload = {
      appId: this.applicationId,
      recipientEmail: this.form.data.testEmail,
    };

    console.log('url : ', url);
    console.log('Sending test email payload:', payload);

    this.locator.http.post(url, payload, (res: any, error: any) => {
      if (error) {
        console.error('Error sending test email:', error);
        alert('Error: ' + error.message);
        return;
      }

      //  Always show backend response message
      if (res) {
        alert(res.message || 'No response message from server');
      } else {
        alert('No response received from server');
      }

      // clear field after sending
      this.form.data.testEmail = '';
    });
  }
}
